import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

const useAxios = () => {
  const tokenRef = useRef<string>("");
  const [token, setToken] = useState<string | null>(null);
  const client = useRef(axiosClient);

  useEffect(() => {
    // リクエストインターセプターで動的にヘッダーを追加
    client.current.interceptors.request.use(
      (config) => {
        if (process.env.NODE_ENV === "development") {
          console.log(config);
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }, []);

  useEffect(() => {
    // リクエストインターセプターで動的にヘッダーを追加
    client.current.interceptors.response.use(
      (response) => {
        if (process.env.NODE_ENV === "development") {
          console.log(response);
        }
        return response;
      }, // 成功時はそのままレスポンスを返す
      (error) => {
        if (process.env.NODE_ENV === "development") {
          console.log(error);
        }
        return Promise.reject(error); // エラーをそのまま返す
      }
    );
  }, []);

  // ヘッダーを更新する関数
  const updateToken = useCallback((token: string) => {
    tokenRef.current = token;
    setToken(token);
  }, []);

  return { axiosClient: client.current, updateToken, token };
};

export { useAxios };
